import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcUplink = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.911 17.742c.09.205.185.404.287.593a6.953 6.953 0 0 1-3.197-2.873h2.207c.175.842.413 1.612.703 2.28ZM7.965 13.9H5.338a6.93 6.93 0 0 1-.264-1.9c0-.658.092-1.295.264-1.898h2.627A18.117 18.117 0 0 0 7.867 12c0 .651.034 1.288.098 1.9Zm.242-5.362H6.001a6.954 6.954 0 0 1 3.196-2.872 8.52 8.52 0 0 0-.286.591c-.29.668-.529 1.439-.704 2.281Zm3.038-3.08c.303-.294.557-.383.755-.383h.002c.198 0 .451.09.753.383.306.297.617.765.895 1.405.212.485.396 1.05.542 1.675H9.807c.147-.625.33-1.19.542-1.675.278-.64.59-1.108.896-1.405ZM14.8 18.335a6.954 6.954 0 0 0 3.2-2.873h-2.207a11.722 11.722 0 0 1-.704 2.28 8.08 8.08 0 0 1-.287.593Zm1.233-4.436h2.628a6.93 6.93 0 0 0 .263-1.9 6.93 6.93 0 0 0-.263-1.898h-2.628a18.106 18.106 0 0 1 0 3.798Zm-.242-5.362H18a6.954 6.954 0 0 0-3.197-2.872c.102.189.197.386.286.591.291.668.53 1.439.704 2.281Zm-1.223 3.462c0-.66-.038-1.296-.108-1.898H9.538a16.51 16.51 0 0 0-.107 1.898c0 .66.037 1.297.107 1.9h4.923c.07-.602.108-1.24.108-1.9Zm-.919 5.138a9.83 9.83 0 0 0 .542-1.675H9.808c.146.625.33 1.19.541 1.675.278.639.59 1.107.896 1.404.303.294.557.383.755.383.198 0 .452-.089.755-.383.306-.297.617-.765.895-1.404Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Zm-2.01 0a8.49 8.49 0 1 1-16.98 0 8.49 8.49 0 0 1 16.98 0Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcUplink");

export { IcUplink };
//# sourceMappingURL=ic-uplink.js.map
